var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.137 74.59c-0.86328 0.42969-2.8008 0.89062-5.3242 0.89062-7.168 0-10.859-4.4609-10.859-10.367 0-7.0781 5.0469-11.016 11.324-11.016 2.4297 0 4.2773 0.49219 5.1055 0.92188l-0.95312 3.7227c-0.95313-0.39844-2.2773-0.76953-3.9375-0.76953-3.7227 0-6.6133 2.2461-6.6133 6.8594 0 4.1523 2.4609 6.7695 6.6445 6.7695 1.4141 0 2.9844-0.30859 3.9062-0.67578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.367 70.344c1.2617 0.64844 3.1992 1.293 5.1992 1.293 2.1523 0 3.293-0.89062 3.293-2.2461 0-1.293-0.98438-2.0312-3.4766-2.9219-3.4453-1.1992-5.6914-3.1094-5.6914-6.1211 0-3.5352 2.9531-6.2461 7.8438-6.2461 2.3398 0 4.0625 0.49219 5.293 1.0469l-1.0469 3.7852c-0.83203-0.39844-2.3086-0.98438-4.3398-0.98438s-3.0156 0.92188-3.0156 2c0 1.3242 1.168 1.9062 3.8477 2.9219 3.6602 1.3555 5.3828 3.2617 5.3828 6.1836 0 3.4766-2.6758 6.4297-8.3672 6.4297-2.3711 0-4.707-0.61719-5.875-1.2617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.719 75.176l-6.6445-20.738h5.1367l2.5234 8.7695c0.70703 2.4609 1.3555 4.832 1.8477 7.4141h0.09375c0.52344-2.4922 1.168-4.9531 1.875-7.3203l2.6445-8.8594h4.9844l-6.9844 20.738z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.98 22.797h14.945c-4.4844-6.2969-13.258-16.27-18.223-20.633v16.871c0 2.0742 1.4727 3.7617 3.2773 3.7617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.734 40.992v-12.852h-17.754c-4.375 0-7.9375-4.0859-7.9375-9.1094v-19.031h-43.469c-3.0977 0-5.6094 2.8789-5.6094 6.4336v19.809h0.011718v18.852h81.73v38.609h-81.73v9.6875c0.125 3.4297 2.5781 6.168 5.5977 6.168h63.555c3.0977 0 5.6055-2.8828 5.6055-6.4336v-5.3125h11.078v-46.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvFile);
export default __webpack_public_path__ + "static/media/csvFile.b4bb1b05.svg";
export { ForwardRef as ReactComponent };